import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { NewPasswordFormSchema, NewPasswordMutation } from './NewPasswordForm.types';
import { getNewPasswordForm } from './NewPasswordForm.schema';
import { useMutation, useQueryClient } from 'react-query';
import Form from '../../../../commons/Form/Form';
import { useState } from 'react';
import NewPasswordModal from '../NewPasswordModal/NewPasswordModal';
import { useParams } from 'react-router-dom';
import { UserRoles } from '../../../../../types/models/user/user.types';
import { newPasswordFormData } from './NewPasswordForm.data';
import { UPDATE_PASSWORD_QUERY_KEY, updatePasswordQuery } from './NewPasswordForm.query';
import Loading from '../../../../commons/Loading/Loading';
import { useForgotPasswordData } from '../../../../../hooks/fetchers/useForgotPasswordData/useForgotPasswordData';

export default () => {
  const { role, hash } = useParams<{ role: UserRoles; hash: string }>();

  const queryClient = useQueryClient();

  const [isModalOpen, setModalOpen] = useState(false);

  const { data } = useForgotPasswordData({ role, hash });

  const formProps = useForm<NewPasswordFormSchema>({
    resolver: yupResolver(getNewPasswordForm),
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      email: data?.email,
    },
  });

  const { handleSubmit } = formProps;

  const { mutate, isLoading } = useMutation<
    Awaited<ReturnType<NewPasswordMutation>>,
    Error,
    NewPasswordFormSchema
  >((data) => updatePasswordQuery({ password: data.password, role, hash }), {
    mutationKey: UPDATE_PASSWORD_QUERY_KEY,
    onMutate: () => queryClient.cancelMutations(),
    onSuccess: ({ success }) => {
      if (success) {
        setModalOpen(true);
      }
    },
    onError: async (error) => alert(error.message),
  });

  const onSubmit = handleSubmit((data) => mutate(data));

  if (isLoading) return <Loading />;

  return (
    <>
      <Form<NewPasswordFormSchema>
        data={newPasswordFormData}
        {...{ formProps, onSubmit }}
        isCompany={role === UserRoles.Entreprise}
      />
      <NewPasswordModal isOpen={isModalOpen} setOpen={setModalOpen} />
    </>
  );
};
